import React from 'react';
import ReactDOM from 'react-dom';
import { ConfigProvider } from 'antd';
import enGB from 'antd/lib/locale/en_GB';
import 'antd/dist/antd.less';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import store, { StoreProvider } from './redux/store';
import moment from 'moment';
import 'moment/locale/en-gb';
import { BrowserRouter as Router } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { isProd } from './utils/constants';
import { generateNewBackOfficeUrl, NEW_BO_APP_REDIRECT_MAP } from './utils/new-bo-urls';
import { applyFavicon } from './utils/favicon';

applyFavicon();

if (isProd) {
    Sentry.init({
        dsn: 'https://f57bfd57c0a1adebac8597d6500dfe75@o515181.ingest.us.sentry.io/4509603498819584',
        tracesSampleRate: 1,
        debug: false,
        replaysOnErrorSampleRate: 1.0,
        replaysSessionSampleRate: 1.0,
        environment: process.env.REACT_APP_BASE_DOMAIN,
        sendDefaultPii: true,
        integrations: [
            Sentry.httpClientIntegration(),
            Sentry.replayIntegration({
                maskAllText: false,
                blockAllMedia: false,
                networkDetailAllowUrls: [''],
                beforeAddRecordingEvent(event) {
                    if (event.data.tag === 'performanceSpan') {
                        const { payload } = event.data;

                        if (payload.op !== 'resource.xhr' && payload.op !== 'resource.fetch') {
                            return null;
                        }

                        const ignoredUrls = ['/static/'];

                        if (ignoredUrls.some(ignoredUrl => payload.description.includes(ignoredUrl))) {
                            return null;
                        }
                    }

                    return event;
                },
            }),
        ],
    });
}

moment.locale('en-gb');

const newBoAppPath = NEW_BO_APP_REDIRECT_MAP[window.location.pathname];

if (newBoAppPath !== undefined && window.location.hostname !== 'localhost') {
    window.location.replace(generateNewBackOfficeUrl(newBoAppPath));
} else {
    ReactDOM.render(
        <React.StrictMode>
            <StoreProvider store={store}>
                <ConfigProvider locale={enGB}>
                    <Router>
                        <App />
                    </Router>
                </ConfigProvider>
            </StoreProvider>
        </React.StrictMode>,
        document.getElementById('root'),
    );

    // If you want to start measuring performance in your app, pass a function
    // to log results (for example: reportWebVitals(console.log))
    // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
    reportWebVitals();
}
